module.exports = __webpack_public_path__ + "media/images/project/project_menu-f0af431309e1d7d3e1c597ad70957182.svg";